import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=4252b2c2&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=js&"
export * from "./MediaUpload.vue?vue&type=script&lang=js&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=4252b2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252b2c2",
  null
  
)

export default component.exports